var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrapper',{attrs:{"title":_vm.$t('page.currentUser.profile.title'),"subtitle":_vm.user.displayName}},[_c('nav-tabs',{attrs:{"items":_vm.navTabs,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }